import React from 'react'
import { Sun, MusicalNote, Loudspeaker, Trophy, Masks, Voucher } from '@ticketswap/comets'
import { color } from '@ticketswap/solar'

export const categories = [
  {
    image: '/static/images/categories/festivals.jpg',
    i18nKey: 'common:categories.festivals',
    value: 'FESTIVALS',
    slug: 'festivals',
    icon: <Sun />,
    color: color.sun,
  },
  {
    image: '/static/images/categories/concerts.jpg',
    i18nKey: 'common:categories.concerts',
    value: 'CONCERTS',
    slug: 'concerts',
    icon: <MusicalNote />,
    color: color.earth,
  },
  {
    image: '/static/images/categories/club-nights.jpg',
    i18nKey: 'common:categories.clubs',
    value: 'CLUBS',
    slug: 'clubs',
    icon: <Loudspeaker />,
    color: color.space,
  },
  {
    image: '/static/images/categories/sports.jpg',
    i18nKey: 'common:categories.sports',
    value: 'SPORTS',
    slug: 'sports',
    icon: <Trophy />,
    color: color.titan,
  },
  {
    image: '/static/images/categories/theatre-comedy.jpg',
    i18nKey: 'common:categories.theatre',
    value: 'THEATRE_AND_COMEDY',
    slug: 'theatre-and-comedy',
    icon: <Masks />,
    color: color.mars,
  },
  {
    image: '/static/images/categories/vouchers-day-out.jpg',
    i18nKey: 'common:categories.vouchers',
    value: 'VOUCHERS_AND_DAY_OUT',
    slug: 'vouchers-and-day-out',
    icon: <Voucher />,
    color: color.spaceMedium,
  },
]

export function getCategories(t) {
  return categories.map(item => ({
    image: item.image,
    name: t(item.i18nKey),
    value: item.value,
    slug: item.slug,
    icon: item.icon,
    color: item.color,
  }))
}
